<template>
  <Layout>
    <PageHeader :title="'Kapatılmamış Faturalar'" :items="breadcrumbArray"></PageHeader>
    <v-app>
      <div class="row">
        <div class="col-lg-12">
          <Results></Results>
        </div>
      </div>
    </v-app>

  </Layout>
</template>

<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import Results from "@/components/my-account/unclosed-invoices/Results.vue"
import {mapState} from "vuex";

export default {
  page: {
    title: "Kapatılmamış Faturalar",
    meta: [{ name: "description", content: "Kapatılmamış Faturalar" }],
  },
  components: {
    Layout,
    PageHeader,
    Results
  },
  computed: {
    ...mapState("current", ["currentActionList", "currentActionListHeaders", "currentActionListLoading"])
  },
  data() {

    return {
      currentPage: 1,


      breadcrumbArray: [
        {
          text: "Hesabım",
          active: false,
        },
        {
          text: "Kapatılmamış Faturalar",
          active: true,
        },
      ],

    };
  },
  methods: {

  },
};
</script>